import React from "react";
import { useNavigate } from "react-router-dom";
import ModulePage from "@/components/ModulePage";

const columns = [
  { key: "name", label: "Name" },
  { key: "code", label: "Code", mono: true },
  { key: "location", label: "Location" },
  { key: "city", label: "City" },
  { key: "state", label: "State" },
  { key: "pincode", label: "Pincode" },
];
const fields = [
  { key: "name", label: "Name" },
  // Feb 27 2026 — short code (e.g. BLR, NOIDA). Prefixed to auto-generated
  // system_ids for orders whose account is tied to this warehouse.
  { key: "code", label: "Code (system_id prefix, e.g. BLR)" },
  { key: "location", label: "Location", span: 2 },
  // Feb 25 2026 — structured warehouse address for shipping labels.
  { key: "address_line_1", label: "Address Line 1", span: 2 },
  { key: "address_line_2", label: "Address Line 2", span: 2 },
  { key: "city", label: "City" },
  { key: "state", label: "State" },
  { key: "pincode", label: "Pincode" },
  { key: "country", label: "Country" },
];

export default function WarehousePage() {
  const navigate = useNavigate();
  return (
    <ModulePage
      moduleKey="warehouse"
      title="Warehouses"
      subtitle="Click a warehouse to see its inventory"
      columns={columns}
      fields={fields}
      filterFields={["name", "location"]}
      onRowClick={(row) => navigate(`/warehouse/${row.id}`)}
      rowActions
    />
  );
}
